import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=4c644697&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=4c644697&prod&lang=scss&scoped=true"
import style1 from "./ImageEditor.vue?vue&type=style&index=1&id=4c644697&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c644697",
  null
  
)

export default component.exports